import { render } from "./CriticalFunc.vue?vue&type=template&id=b21dd6ee&scoped=true"
import script from "./CriticalFunc.vue?vue&type=script&lang=js"
export * from "./CriticalFunc.vue?vue&type=script&lang=js"

import "./CriticalFunc.vue?vue&type=style&index=0&id=b21dd6ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21dd6ee"]])

export default __exports__